import moment from "moment";
import MomentUtils from "@date-io/moment";
import React, { useState } from "react";
import {localization} from '../../Frames/localization'

import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
    KeyboardDatePicker,
  } from '@material-ui/pickers';
  import "moment/locale/uk";
  import "moment/locale/ru";
  import "moment/locale/en-au";
  import "moment/locale/pl";
  import "moment/locale/fr";
  import "moment/locale/de";
  import "moment/locale/es";
  import "moment/locale/zh-cn";
import { AppliedSettings } from "../../App";


 // it is required to select default locale manually
function MomentLocalizationExample(props) {
  const [locale] = useState(localization.chooseLangPickers(AppliedSettings.calendar_language_first, AppliedSettings.calendar_language_second));
  //moment.locale(i18next.options.lng);
  moment.locale(localization.chooseLangPickers(AppliedSettings.calendar_language_first, AppliedSettings.calendar_language_second))
  const handleDateChange = date => {
    props.setstartDate(date);
  };
  return (
    <div> 
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={locale}>
        <KeyboardDatePicker
            autoOk={true}
            className={props.className}
            variant="inline"
            format="DD/MM/YYYY"
            margin="normal"
            label={props.label}
            required={props.required}
            value={props.value}
            onChange={handleDateChange}
            KeyboardButtonProps={{
                'aria-label': 'change date',
            }}
            invalidDateMessage={localization.GetTranslate('Profile.Invalid Date Format')}
            maxDateMessage={localization.GetTranslate('Profile.Date should not be after maximal date')}
            minDateMessage={localization.GetTranslate('Profile.Date should not be before minimal date')}
            />
        </MuiPickersUtilsProvider>
    </div>
  );
}

export default MomentLocalizationExample;